// ABOUTME: File input component with consistent styling
// ABOUTME: Provides styled file upload input with helper text support

import * as React from "react"
import { cn } from "@shared/lib/utils"

export interface CFileInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  sizing?: "sm" | "md" | "lg"
  color?: "gray" | "info" | "failure" | "warning" | "success"
  helperText?: React.ReactNode
}

const sizeClasses = {
  sm: "text-sm file:py-1 file:px-2",
  md: "text-sm file:py-2 file:px-3",
  lg: "text-base file:py-2.5 file:px-4",
}

const colorClasses = {
  gray: "border-gray-300 focus:border-primary focus:ring-primary",
  info: "border-blue-500 focus:border-blue-500 focus:ring-blue-500",
  failure: "border-red-500 focus:border-red-500 focus:ring-red-500",
  warning: "border-yellow-500 focus:border-yellow-500 focus:ring-yellow-500",
  success: "border-green-500 focus:border-green-500 focus:ring-green-500",
}

export const CFileInput = React.forwardRef<HTMLInputElement, CFileInputProps>(
  ({ className, sizing = "md", color, helperText, ...props }, ref) => {
    return (
      <div>
        <input
          type="file"
          ref={ref}
          className={cn(
            "block w-full cursor-pointer rounded-lg border bg-gray-50 text-gray-900",
            "file:mr-4 file:border-0 file:bg-gray-200 file:text-gray-700 file:cursor-pointer",
            "hover:file:bg-gray-300",
            "focus:outline-none focus:ring-1",
            "disabled:cursor-not-allowed disabled:opacity-50",
            sizeClasses[sizing],
            color ? colorClasses[color] : colorClasses.gray,
            className,
          )}
          {...props}
        />
        {helperText && (
          <p className={cn("mt-1 text-sm", color === "failure" ? "text-red-600" : "text-gray-500")}>{helperText}</p>
        )}
      </div>
    )
  },
)

CFileInput.displayName = "CFileInput"
